import { MapPin, Loader2, X } from 'lucide-react';
import type { GeoStatus } from '../hooks/useGeolocation';

interface Props {
  status: GeoStatus;
  radiusMiles: number;
  error: string | null;
  onRequest: () => void;
  onClear: () => void;
}

function fmtRadius(value: number): string {
  return Number.isInteger(value) ? value.toString() : value.toString();
}

export function NearbyButton({ status, radiusMiles, error, onRequest, onClear }: Props) {
  if (status === 'active') {
    return (
      <div className="flex items-center gap-1">
        <span className="inline-flex items-center px-3 py-2 bg-snhd-primary text-white rounded-lg text-sm font-medium">
          <MapPin className="w-4 h-4 mr-1" aria-hidden />
          Nearby ({fmtRadius(radiusMiles)} mi)
        </span>
        <button
          type="button"
          onClick={onClear}
          aria-label="Clear nearby"
          className="inline-flex items-center p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-md"
        >
          <X className="w-4 h-4" aria-hidden />
        </button>
      </div>
    );
  }

  const requesting = status === 'requesting';
  const showError = status === 'error' && error !== null;

  return (
    <div className="flex flex-col items-start gap-1">
      <button
        type="button"
        onClick={onRequest}
        disabled={requesting}
        className="inline-flex items-center px-3 py-2 bg-snhd-primary text-white rounded-lg hover:bg-snhd-primary-hover transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {requesting ? (
          <>
            <Loader2 className="w-4 h-4 mr-1 animate-spin" aria-hidden />
            <span className="font-medium">Locating…</span>
          </>
        ) : (
          <>
            <MapPin className="w-4 h-4 mr-1" aria-hidden />
            <span className="font-medium">Nearby Restaurants</span>
          </>
        )}
      </button>
      {showError && (
        <p className="text-xs text-red-700">{error}</p>
      )}
    </div>
  );
}
